// mutation spotifyUpdateClientDashboardSettings($clientId: ID!, $clientKpi: String, $clientBreakdown: String) {
//     updateClient(clientId: $clientId, clientKpi: $clientKpi, clientBreakdown: $clientBreakdown) {
//         id: clientId
//         clientKpi
//         clientBreakdown
//     }
// }

import { DocumentNode } from 'graphql';
import useAdAccountDashboardStore from 'auth/lib/useAdAccountDashboardStore';

// }
export default function getUpdateClientDashboardSettingsResult(query: DocumentNode, variables: Record<string, any>) {
	const clientId = variables?.clientId;
	const clientKpi = variables?.clientKpi;
	const clientBreakdown = variables?.clientBreakdown;

	useAdAccountDashboardStore.getState().updateAdAccountSettings(clientId, {
		clientKpi,
		clientBreakdown,
	});

	return {
		updateClient: {
			id: clientId,
			clientKpi,
			clientBreakdown,
		},
	};
}
